import { Box, Button, Checkbox, FormControlLabel, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { clickElement, focusElemnt, isEmpty, navigation3, removeDuplicatesFromArray } from '../../../../common/helper'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import { XMarkSvg } from '../../../../common/svg/xMark'
import { CheckMarkSvg } from '../../../../common/svg/checkMark'
import moment from 'moment'
import EditIcon from '@mui/icons-material/Edit'
import { Item } from '../../../../common/snippets'
import DropDownOA from '../../../../common/dropDownOA'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import { updateAlertError } from '../../../../../store/common/common_action'
import { connect } from 'react-redux'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import { billingUnitList, cellStyles, serviceTypeList, statusListWithAll } from '../constants'
import AddNewPartyRatesModal from './AddNewPartyRatesModal'
import { getFocApprConsTypeData, getPartyConfigTableData, getPartyRateMatrixTableData, getParyRateUpdate } from '../../../../../store/generalSetting/GSAction'
import SuccessAndErrorModal from '../../../../common/SuccessAndErrorModal'
import { getCityList } from '../../../../../store/branchAndUserMaster/BUMAction'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import { useTranslation } from '../../../../../i18n/I18nProvider'
import { STA_COMPANY_ID, DEMO_COMPANY } from '../../../../../helper/companyIdhardcode'

const PartyRateMatrixTable = (props) => {
  const { translations, language } = useTranslation()
  const cs = translations?.common || {}
  const { data, updateAlertError, getFocApprConsTypeData, getPartyConfigTableData, getPartyRateMatrixTableData, getParyRateUpdate, getCityList } = props
  const { common, generalSettingReducer } = data
  const { loginData } = common
  const { focApprConsTypeData, partyConfigTableData } = generalSettingReducer
  const gs = translations?.generalSettings || {}
  const tr = (key, fallback) => gs?.[key] || fallback
  const mapTranslated = (list = []) =>
    list.map((item) => ({ ...item, name: tr(item.translationKey, item.name) }))
  const translatedServiceTypeList = mapTranslated(serviceTypeList)
  const translatedBillingUnitList = mapTranslated(billingUnitList)
  const translatedStatusListWithAll = mapTranslated(statusListWithAll)
  const isSTA = loginData?.intCompanyID === STA_COMPANY_ID || loginData?.intCompanyID === DEMO_COMPANY;
  const [tableData, setTableData] = useState([])
  const [filteredData, setfilteredData] = useState(tableData)
  const [showAddPartyRateModal, setShowAddPartyRateModal] = useState(false)
  const [addPartyRateData, setAddPartyRateData] = useState({})
  const [consTypeList, setConsTypeList] = useState([])
  const [partyList, setPartyList] = useState([])
  const [filters, setFilters] = useState({ partyName: '', serviceType: serviceTypeList?.[0], consignmentType: '', billingUnit: billingUnitList?.[0], status: statusListWithAll?.[0] })
  const [editData, setEditData] = useState({})
  const [isSuccess, setIsSuccess] = useState(false)
  const [cityList, setCityList] = useState([])
  const [searchData, setSearchData] = useState({
    PartyID: "",
    Party: "",
    ServiceTypeID: "",
    ServiceType: "",
    ConsignmentID: "",
    ConsignmentType: "",
    BillingUnitName: "",
    SourceCity: "",
    DestinationCity: "",
    assignedRate: "",
    assignedDocumentCharge: "",
    assignedValuationCharge: "",
    assignedGoodsValue: "",
    assignedDiscOnFreight: "",
    ModifiedBy: "",
    ModifiedDate: ''
  })
  const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }

  useEffect(() => {
    focusElemnt('selectParty')
  }, [])

  useEffect(() => {
    setFilters((prev) => ({
      ...prev,
      serviceType: translatedServiceTypeList.find((item) => item.id === prev?.serviceType?.id) || translatedServiceTypeList[0],
      billingUnit: translatedBillingUnitList.find((item) => item.id === prev?.billingUnit?.id) || translatedBillingUnitList[0],
      status: translatedStatusListWithAll.find((item) => item.id === prev?.status?.id) || translatedStatusListWithAll[0],
    }))
  }, [translations])

  const getAddPartyRatesModalInfo = () => {
    let data = {
      loginData: loginData,
      filters: filters,
      cityList: cityList
    }
    setShowAddPartyRateModal(true)
    setAddPartyRateData(data)
  }

  const staEditableColumns = [
    { headerName: 'Document\nCharge', translationKey: 'documentCharge', field: 'assignedDocumentCharge', headerSx: { padding: '6px', textAlign: 'right', minWidth: '5.69%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Valuation\nCharge', translationKey: 'valuationCharge', field: 'assignedValuationCharge', headerSx: { padding: '6px', textAlign: 'right', minWidth: '5.69%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Goods\nValue', translationKey: 'goodsValue', field: 'assignedGoodsValue', headerSx: { padding: '6px', textAlign: 'right', minWidth: '5.69%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Discount', translationKey: 'discount', field: 'assignedDiscOnFreight', headerSx: { padding: '6px', textAlign: 'right', minWidth: '5.69%' }, dataType: 'string', showfilter: true, allowSorting: false },
  ]

  const baseColumnDefs = [
    { headerName: 'S/N', translationKey: 'sn', field: 'SN', headerSx: { padding: '6px', textAlign: 'right', minWidth: '2.54%' }, dataType: 'string', showfilter: false, allowSorting: false },
    { headerName: 'Party\nID', translationKey: 'partyIdNl', field: 'PartyID', headerSx: { padding: '6px', textAlign: 'left', minWidth: '4.42%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Party\nName', translationKey: 'partyNameNl', field: 'Party', headerSx: { padding: '6px', textAlign: 'left', minWidth: '8.5%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Service \nType ID', translationKey: 'serviceTypeId', field: 'ServiceTypeID', headerSx: { padding: '6px', textAlign: 'left', minWidth: '4.94%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Service\nType ', translationKey: 'serviceType', field: 'ServiceType', headerSx: { padding: '6px', textAlign: 'left', minWidth: '7.04%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Cons.\nType ID', translationKey: 'consTypeIdNl', field: 'ConsignmentID', headerSx: { padding: '6px', textAlign: 'left', minWidth: '5.2%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Consignment\nType ', translationKey: 'consignmentType', field: 'ConsignmentType', headerSx: { padding: '6px', textAlign: 'left', minWidth: '8.69%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Billing\nUnit ', translationKey: 'billingUnit', field: 'BillingUnitName', headerSx: { padding: '6px', textAlign: 'left', minWidth: '7.04%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Source\nCity', translationKey: 'sourceCity', field: 'SourceCity', headerSx: { padding: '6px', textAlign: 'left', minWidth: '8.47%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Destination\nCity', translationKey: 'destinationCity', field: 'DestinationCity', headerSx: { padding: '6px', textAlign: 'left', minWidth: '8.47%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Assigned\nRate', translationKey: 'assignedRateNl', field: 'assignedRate', headerSx: { padding: '6px', textAlign: 'right', minWidth: '5.69%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Modified\nBy', translationKey: 'modifiedBy', field: 'ModifiedBy', headerSx: { padding: '6px', textAlign: 'left', minWidth: '8.69%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Mod. Date\n& Time', translationKey: 'modDateTimeNl', field: 'ModifiedDate', headerSx: { padding: '6px', textAlign: 'left', minWidth: '13.5%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Status', translationKey: 'status', field: 'active', headerSx: { padding: '6px', textAlign: 'center', minWidth: '4.34%' }, dataType: 'string', showfilter: false, allowSorting: false },
    { headerName: 'Edit', translationKey: 'edit', field: 'edit', headerSx: { padding: '6px', textAlign: 'left', minWidth: '%' }, dataType: 'string', showfilter: false, allowSorting: false },
  ]
  const assignedRateIndex = baseColumnDefs.findIndex((col) => col.field === 'assignedRate')
  const columnDefs = isSTA && assignedRateIndex >= 0
    ? [...baseColumnDefs.slice(0, assignedRateIndex + 1), ...staEditableColumns, ...baseColumnDefs.slice(assignedRateIndex + 1)]
    : baseColumnDefs
  const columnDefs1 = columnDefs.filter((col) => col.field !== 'edit')
  const translatedColumnDefs = columnDefs.map((col) => ({ ...col, headerName: tr(col.translationKey, col.headerName) }))
  const translatedColumnDefs1 = columnDefs1.map((col) => ({ ...col, headerName: tr(col.translationKey, col.headerName) }))

  useEffect(() => {
    getTableData()
  }, [])
  useEffect(() => setfilteredData(tableData), [tableData])
  const EmptyTableRow = () => {
    return (
      <TableRow>
        <TableCell colSpan={translatedColumnDefs.length}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '15px',
              marginBottom: '15px',
              color: 'red',
              fontSize: '14px',
            }}
          >
            <span>{tr('noResultsFoundShort', 'No results found.')}</span>
          </div>
        </TableCell>
      </TableRow>
    )
  }
  useEffect(() => {
    if (!isEmpty(loginData)) {
      let obj = {
        intConsignmentSubTypeID: 0,
        intCompanyID: loginData?.intCompanyID,
        intConsignmentTypeID: 0,
        strSubType: "",
        intIsActive: 1,
        intIsDeleted: 0
      }
      getFocApprConsTypeData(obj, true, 24 * 60 * 60 * 1000)


      let object = {
        intPartyID: 0,
        intCompanyID: loginData?.intCompanyID,
        strPartyName: "",
        strContactPerson: "",
        intCityID: 0,
        intIsCreditParty: -1,
        intIsActive: -1,
        intIsDeleted: -1
      }
      getPartyConfigTableData(object)

      let body1 = {
      }
      getCityList(body1, true, 24 * 60 * 60 * 1000).then((res) => {
        if (res.status === 'Success') {
          let newData = removeDuplicatesFromArray(res.Data.Table, 'CityID')
          const cityNames = newData.map(city => ({ CityID: city.CityID, CityName: city.Cityname }));
          setCityList(cityNames)
        } else {
          setCityList([])
        }
      }).catch((err) => {
        console.log('Error:', err)
      })
    }
  }, [loginData])
  useEffect(() => {

  }, [loginData])
  const getTableData = () => {
    let obj = {
      PartyID: filters?.partyName?.PartyID,
      CompanyID: loginData?.intCompanyID,
      ConsignmentTypeID: filters?.consignmentType?.id,
      ServiceTypeID: filters?.serviceType?.id,
      BillingUnit: filters?.billingUnit?.id,
      IsActive: filters?.status?.id
    }
    getPartyRateMatrixTableData(obj).then((res) => {
      if (res.status === 'Success') {
        let data = res?.Data?.Table
        let newData = data?.map((val, i) => ({
          ...val,
          editBtn: true,
          assignedRate: val.Rate,
          assignedDocumentCharge: val.PartyDocumentCharge,
          assignedValuationCharge: val.PartyValuationCharge,
          assignedGoodsValue: val.PartyGoodsValue,
          assignedDiscOnFreight: val.DiscOnFreight,
          active: val.IsActive,
          ModifiedDate: val.ModifiedDatetime === '' || val.ModifiedDatetime === null || val.ModifiedDatetime === undefined ? '' : moment(val.ModifiedDatetime).format('DD-MMM-YYYY, HH:mm')
        }))
        setTableData(newData)
      }
      else {
        setTableData([])
      }
    }).catch((err) => {
      updateAlertError({ show: true, msg: err, nextId: '' })
      console.log("Error:", err)
    })
  }
  useEffect(() => {
    if (focApprConsTypeData?.length > 0) {
      let newData = [{ id: -1, name: tr('gsAll', 'All'), translationKey: 'gsAll' }]
      focApprConsTypeData.map(function (obj) {
        newData.push({
          id: obj.ConsignmentSubTypeID,
          name: obj.SubType,
        })
      })
      newData = removeDuplicatesFromArray(newData, `id`)
      newData.sort((a, b) => a.name.localeCompare(b.name))
      setConsTypeList(newData)
      setFilters((prev) => ({
        ...prev,
        consignmentType: newData.find((item) => item.id === prev?.consignmentType?.id) || newData?.[0],
      }))
    } else {
      setConsTypeList([])
    }
  }, [focApprConsTypeData, translations])
  useEffect(() => {
    if (partyConfigTableData?.length > 0) {
      setPartyList(partyConfigTableData)
      setFilters((prev) => ({
        ...prev,
        partyName: partyConfigTableData?.[0],
      }))
    } else {
      setPartyList([])
    }
  }, [partyConfigTableData])
  const handleHideEditBtn = (index) => {
    let newVal = [...filteredData]
    if (index >= 0 && index <= newVal?.length) {
      for (let i = 0; i < newVal?.length; i++) {
        if (i === index) {
          newVal[i].editBtn = !newVal[i].editBtn
        } else {
          newVal[i].editBtn = true
        }
      }
      setfilteredData(newVal)
      const enteringEdit = newVal[index].editBtn === false
      if (enteringEdit) {
        setTimeout(() => {
          focusElemnt(`prmRate-${index}`)
        }, 0)
      } else {
        focusElemnt(`editBtn-${index + 1}`)
      }
    }
  }
  const handleRowChkChange = (e, index) => {
    let newVal = [...filteredData]
    if (index >= 0 && index <= newVal?.length) {
      newVal[index].active = e.target.checked ? 1 : 0
      setfilteredData(newVal)
    }
    setTimeout(() => {
      focusElemnt(`chkbox-${index}`)
    }, 0)
  }
  const handleRowEdit = (row, index) => {
    if (row?.assignedRate === '') {
      updateAlertError({ show: true, msg: tr('pleaseEnterAssignedRate', 'Please Enter Assigned Rate'), success: false, nextId: `prmRate-${index}` })
      return
    }
    if (isSTA && Number(row?.assignedDiscOnFreight) > 100) {
      updateAlertError({
        show: true,
        msg: tr('discOnFreightMax100', 'Discount on Freight cannot exceed 100%'),
        success: false,
        nextId: `prmDisc-${index}`,
      })
      return
    } else {
      let newVal = [...filteredData]
      let obj = {
        CompanyID: loginData?.intCompanyID,
        PartyID: row?.PartyID,
        ConsignmentID: row?.ConsignmentID,
        UserID: loginData?.intUserID,
        FromCityID: row?.SourceCityID,
        ToCityID: row?.DestinationCityID,
        ServiceTypeID: row?.ServiceTypeID,
        BillingUnit: row?.BillingUnit,
        Rate: row?.assignedRate,
        Active: row?.active,
        ...(isSTA && {
          DocumentCharge: Number(row?.assignedDocumentCharge),
          ValuationCharge: Number(row?.assignedValuationCharge),
          GoodsValue:  Number(row?.assignedGoodsValue),
          dblDiscOnFreight: Number(row?.assignedDiscOnFreight)
        })
      }
      getParyRateUpdate(obj)?.then((res) => {
        if (res?.status == 'Success') {
          setIsSuccess(true)
          if (index >= 0 && index <= newVal?.length) {
            newVal[index].editBtn = !newVal[index].editBtn
            setfilteredData(newVal)
          }
        } else {
          updateAlertError({ show: true, msg: res.Message, success: false, nextId: `focApprConsType` })
        }
      }).catch((err) => {
        console.log("Error:", err)
      })
    }
  }
  const handleCrossBtn = (index) => {
    let newVal = [...filteredData]
    if (index >= 0 && index <= newVal?.length) {
      newVal[index].assignedRate = newVal[index].Rate
      if (isSTA) {
        newVal[index].assignedDocumentCharge = newVal[index].PartyDocumentCharge
        newVal[index].assignedValuationCharge = newVal[index].PartyValuationCharge
        newVal[index].assignedGoodsValue = newVal[index].PartyGoodsValue
        newVal[index].assignedDiscOnFreight = newVal[index].DiscOnFreight
      }
      newVal[index].active = newVal[index].IsActive
      newVal[index].editBtn = !newVal[index].editBtn
      setfilteredData(newVal)
      setTimeout(() => {
        focusElemnt(`editBtn-${index + 1}`)
      }, 0)
    }
  }
  const handleInputChange = (e, index, field = 'assignedRate') => {
    let value = e.target.value;
    const regex = /^\d*\.?\d{0,2}$/;
    if (regex.test(value) || value === '') {
        if (field === 'assignedDiscOnFreight' && value !== '' && Number(value) > 100) {
          updateAlertError({
            show: true,
            msg: tr('discOnFreightMax100', 'Discount on Freight cannot exceed 100%'),
            success: false,
            nextId: `prmDisc-${index}`,
          })
          return
        }
        let newVal = [...filteredData];
        if (index >= 0 && index < newVal.length) {
            newVal[index] = { ...newVal[index], [field]: value };
            setfilteredData(newVal);
        }
    }
  }

  const handleLoad = () => {

  }
  const handleSuccessModalClose = () => {
    setIsSuccess(false)
    getTableData()
  }
  const handleSearchData = (event, field) => {
    setSearchData({ ...searchData, [field]: event.target.value.toString() })
  }
  useEffect(() => {
    let fiterData = tableData.filter((val) =>
      (searchData?.PartyID === "" || (val?.PartyID && val?.PartyID?.toString().toLocaleLowerCase().includes(searchData?.PartyID?.toLocaleLowerCase()))) &&
      (searchData?.Party === "" || (val?.Party && val?.Party?.toLocaleLowerCase().includes(searchData?.Party?.toLocaleLowerCase()))) &&
      (searchData?.ServiceTypeID === "" || (val?.ServiceTypeID && val?.ServiceTypeID?.toString().toLocaleLowerCase().includes(searchData?.ServiceTypeID?.toLocaleLowerCase()))) &&
      (searchData?.ServiceType === "" || (val?.ServiceType && val?.ServiceType?.toLocaleLowerCase().includes(searchData?.ServiceType?.toLocaleLowerCase()))) &&
      (searchData?.ConsignmentID === "" || (val?.ConsignmentID && val?.ConsignmentID?.toString().toLocaleLowerCase().includes(searchData?.ConsignmentID?.toLocaleLowerCase()))) &&
      (searchData?.ConsignmentType === "" || (val?.ConsignmentType && val?.ConsignmentType?.toLocaleLowerCase().includes(searchData?.ConsignmentType?.toLocaleLowerCase()))) &&
      (searchData?.BillingUnitName === "" || (val?.BillingUnitName && val?.BillingUnitName?.toLocaleLowerCase().includes(searchData?.BillingUnitName?.toLocaleLowerCase()))) &&
      (searchData?.SourceCity === "" || (val?.SourceCity && val?.SourceCity?.toLocaleLowerCase().includes(searchData?.SourceCity?.toLocaleLowerCase()))) &&
      (searchData?.DestinationCity === "" || (val?.DestinationCity && val?.DestinationCity?.toLocaleLowerCase().includes(searchData?.DestinationCity?.toLocaleLowerCase()))) &&
      (searchData?.assignedRate === "" || (val?.assignedRate && val?.assignedRate?.toString().toLocaleLowerCase().includes(searchData?.assignedRate?.toLocaleLowerCase()))) &&
      (!isSTA || searchData?.assignedDocumentCharge === "" || (val?.assignedDocumentCharge && val?.assignedDocumentCharge?.toString().toLocaleLowerCase().includes(searchData?.assignedDocumentCharge?.toLocaleLowerCase()))) &&
      (!isSTA || searchData?.assignedValuationCharge === "" || (val?.assignedValuationCharge && val?.assignedValuationCharge?.toString().toLocaleLowerCase().includes(searchData?.assignedValuationCharge?.toLocaleLowerCase()))) &&
      (!isSTA || searchData?.assignedGoodsValue === "" || (val?.assignedGoodsValue && val?.assignedGoodsValue?.toString().toLocaleLowerCase().includes(searchData?.assignedGoodsValue?.toLocaleLowerCase()))) &&
      (!isSTA || searchData?.assignedDiscOnFreight === "" || (val?.assignedDiscOnFreight && val?.assignedDiscOnFreight?.toString().toLocaleLowerCase().includes(searchData?.assignedDiscOnFreight?.toLocaleLowerCase()))) &&
      (searchData?.ModifiedBy === "" || (val?.ModifiedBy && val?.ModifiedBy?.toLocaleLowerCase().includes(searchData?.ModifiedBy?.toLocaleLowerCase()))) &&
      (searchData?.ModifiedDate === "" || (val?.ModifiedDate && val?.ModifiedDate?.toString().toLocaleLowerCase().includes(searchData?.ModifiedDate?.toLocaleLowerCase())))
    );
    setfilteredData(fiterData);
  }, [searchData]);

  const renderPartyRateMatrixRow = (item, index) => (
      <TableRow key={`auto-trans-recv-${index}`} style={{ minHeight: '36px' }}>
        <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '2.54%', padding: '6px', textAlign: 'right' }}> {index + 1} </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '4.42%', padding: '6px' }}>
          {item.PartyID}
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '8.5%', padding: '6px', maxWidth: '120px' }}>
          <Tooltip title={`${item.Party}`}
            PopperProps={{
              sx: {
                "& .MuiTooltip-tooltip": {
                  backgroundColor: '#DAEDFE',
                  color: "#000",
                  minHeight: '26px',
                  display: 'flex',
                  fontWeight: '400',
                  alignItems: "center",
                  marginTop: '5px !important',
                  fontSize: '12px'
                }
              }
            }}
            placement="bottom-start">
            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', cursor: 'pointer', textDecoration: 'underline' }}>
              {item.Party}
            </span>
          </Tooltip>
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '4.94%', padding: '6px', maxWidth: '120px' }}>
          {item.ServiceTypeID}
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '7.04%', padding: '6px', maxWidth: '120px' }}>
          <Tooltip title={`${item.ServiceType}`}
            PopperProps={{
              sx: {
                "& .MuiTooltip-tooltip": {
                  backgroundColor: '#DAEDFE',
                  color: "#000",
                  minHeight: '26px',
                  display: 'flex',
                  fontWeight: '400',
                  alignItems: "center",
                  marginTop: '5px !important',
                  fontSize: '12px'
                }
              }
            }}
            placement="bottom-start">
            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', cursor: 'pointer' }}>
              {item.ServiceType}
            </span>
          </Tooltip>
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '5.2%', padding: '6px' }}>{item.ConsignmentID}</TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '8.69%', padding: '6px', maxWidth: '116px' }}>
          <Tooltip title={`${item.ConsignmentType}`}
            PopperProps={{
              sx: {
                "& .MuiTooltip-tooltip": {
                  backgroundColor: '#DAEDFE',
                  color: "#000",
                  minHeight: '26px',
                  display: 'flex',
                  fontWeight: '400',
                  alignItems: "center",
                  marginTop: '5px !important',
                  fontSize: '12px'
                }
              }
            }}
            placement="bottom-start">
            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', cursor: 'pointer' }}>
              {item.ConsignmentType}
            </span>
          </Tooltip>
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '7.04%', padding: '6px', maxWidth: '94px' }}>
          <Tooltip title={`${item.BillingUnitName}`}
            PopperProps={{
              sx: {
                "& .MuiTooltip-tooltip": {
                  backgroundColor: '#DAEDFE',
                  color: "#000",
                  minHeight: '26px',
                  display: 'flex',
                  fontWeight: '400',
                  alignItems: "center",
                  marginTop: '5px !important',
                  fontSize: '12px'
                }
              }
            }}
            placement="bottom-start">
            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', cursor: 'pointer' }}>
              {item.BillingUnitName}
            </span>
          </Tooltip>
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '8.47%', padding: '6px', textAlign: 'left', maxWidth: '112px' }}>
          <Tooltip title={`${item.SourceCity}`}
            PopperProps={{
              sx: {
                "& .MuiTooltip-tooltip": {
                  backgroundColor: '#DAEDFE',
                  color: "#000",
                  minHeight: '26px',
                  display: 'flex',
                  fontWeight: '400',
                  alignItems: "center",
                  marginTop: '5px !important',
                  fontSize: '12px'
                }
              }
            }}
            placement="bottom-start">
            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', cursor: 'pointer' }}>
              {item.SourceCity}
            </span>
          </Tooltip>
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '8.47%', padding: '6px', textAlign: 'left', maxWidth: '112px' }}>
          <Tooltip title={`${item.DestinationCity}`}
            PopperProps={{
              sx: {
                "& .MuiTooltip-tooltip": {
                  backgroundColor: '#DAEDFE',
                  color: "#000",
                  minHeight: '26px',
                  display: 'flex',
                  fontWeight: '400',
                  alignItems: "center",
                  marginTop: '5px !important',
                  fontSize: '12px'
                }
              }
            }}
            placement="bottom-start">
            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', cursor: 'pointer' }}>
              {item.DestinationCity}
            </span>
          </Tooltip>
        </TableCell>
        {item.editBtn ? <TableCell style={{ ...cellStyles, width: '5.69%', textAlign: 'right' }}> {item.assignedRate} </TableCell> :
          <TableCell className="input--wrapper" style={{ ...cellStyles, padding: '4px 4px', width: '5.69%', }}>
            <Item sx={{ padding: '0px' }}>
              <input
                id={`prmRate-${index}`}
                name={`prmRate-${index}`}
                className='input--style'
                style={{ fontSize: "12px", textAlign: "right", maxHeight: '27px' }}
                value={item?.assignedRate ?? ''}
                onChange={(e) => handleInputChange(e, index, 'assignedRate')}
              />
            </Item>
          </TableCell>}
        {isSTA && (
          <>
            {item.editBtn ? <TableCell style={{ ...cellStyles, width: '5.69%', textAlign: 'right' }}> {item.assignedDocumentCharge} </TableCell> :
              <TableCell className="input--wrapper" style={{ ...cellStyles, padding: '4px 4px', width: '5.69%' }}>
                <Item sx={{ padding: '0px' }}>
                  <input
                    className='input--style'
                    style={{ fontSize: "12px", textAlign: "right", maxHeight: '27px' }}
                    value={item?.assignedDocumentCharge ?? ''}
                    onChange={(e) => handleInputChange(e, index, 'assignedDocumentCharge')}
                  />
                </Item>
              </TableCell>}
            {item.editBtn ? <TableCell style={{ ...cellStyles, width: '5.69%', textAlign: 'right' }}> {item.assignedValuationCharge} </TableCell> :
              <TableCell className="input--wrapper" style={{ ...cellStyles, padding: '4px 4px', width: '5.69%' }}>
                <Item sx={{ padding: '0px' }}>
                  <input
                    className='input--style'
                    style={{ fontSize: "12px", textAlign: "right", maxHeight: '27px' }}
                    value={item?.assignedValuationCharge ?? ''}
                    onChange={(e) => handleInputChange(e, index, 'assignedValuationCharge')}
                  />
                </Item>
              </TableCell>}
            {item.editBtn ? <TableCell style={{ ...cellStyles, width: '5.69%', textAlign: 'right' }}> {item.assignedGoodsValue} </TableCell> :
              <TableCell className="input--wrapper" style={{ ...cellStyles, padding: '4px 4px', width: '5.69%' }}>
                <Item sx={{ padding: '0px' }}>
                  <input
                    className='input--style'
                    style={{ fontSize: "12px", textAlign: "right", maxHeight: '27px' }}
                    value={item?.assignedGoodsValue ?? ''}
                    onChange={(e) => handleInputChange(e, index, 'assignedGoodsValue')}
                  />
                </Item>
              </TableCell>}
            {item.editBtn ? <TableCell style={{ ...cellStyles, width: '5.69%', textAlign: 'right' }}> {item.assignedDiscOnFreight} </TableCell> :
              <TableCell className="input--wrapper" style={{ ...cellStyles, padding: '4px 4px', width: '5.69%' }}>
                <Item sx={{ padding: '0px' }}>
                  <input
                    id={`prmDisc-${index}`}
                    name={`prmDisc-${index}`}
                    className='input--style'
                    style={{ fontSize: "12px", textAlign: "right", maxHeight: '27px' }}
                    value={item?.assignedDiscOnFreight ?? ''}
                    onChange={(e) => handleInputChange(e, index, 'assignedDiscOnFreight')}
                  />
                </Item>
              </TableCell>}
          </>
        )}
        <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '8.69%', padding: '6px', textAlign: 'left', maxWidth: '112px' }}>
          <Tooltip title={`${item.ModifiedBy}`}
            PopperProps={{
              sx: {
                "& .MuiTooltip-tooltip": {
                  backgroundColor: '#DAEDFE',
                  color: "#000",
                  minHeight: '26px',
                  display: 'flex',
                  fontWeight: '400',
                  alignItems: "center",
                  marginTop: '5px !important',
                  fontSize: '12px'
                }
              }
            }}
            placement="bottom-start">
            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', cursor: 'pointer' }}>
              {item.ModifiedBy}
            </span>
          </Tooltip>
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '13.5%', padding: '6px', textAlign: 'left' }}>{item?.ModifiedDate}</TableCell>
        {item.editBtn ?
          <TableCell sx={{ ...cellStyles, width: '4.34%', textAlign: 'center' }}>
            <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
              {item.active === 1 ? <CheckMarkSvg /> : <XMarkSvg />}
            </span></TableCell>
          : <TableCell style={{ ...cellStyles, width: '4.34%', padding: '0px 0px', textAlign: 'center' }}>
            <Item sx={{ width: '100%', padding: '0px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <FormControlLabel
                value="end"
                sx={{ marginX: '0px', maxHeight: '36px' }}
                control={
                  <Checkbox
                    id={`chkbox-${index}`}
                    checked={item.active === 1}
                    onChange={(e) => handleRowChkChange(e, index)}
                    sx={{ fontSize: '12px', backgroundColor: 'transparent !important', padding: '0px 0px', textAlign: 'center' }}
                  />
                }
                labelPlacement="end"
              />
            </Item>
          </TableCell>}
        {item.editBtn ? <TableCell style={{ ...cellStyles, width: '5.17%' }}>
          <span id={`editBtn-${index}`} tabIndex={0} style={{ display: 'flex', color: '#007bfd', fontSize: '13px', fontWeight: 'bold', width: '52px', padding: '2px 4px', marginLeft: '-6px' }}
            onClick={() => { handleHideEditBtn(index) }}
            onKeyDown={(e) => navigation3(e, index === filteredData?.length - 1 ? 'selectParty' : `editBtn-${index + 1}`, index === 0 ? "AddPartyRateBtn" : `editBtn-${index - 1}`, () => { handleHideEditBtn(index); })}
          >
            <EditIcon sx={{ marginRight: '3px' }} />
            {tr('edit', 'Edit')}
          </span></TableCell> :
          <TableCell style={{ ...cellStyles, width: '5.17%', padding: '0px 0px' }}>
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap' }}>
              <span tabIndex={0} key={`checkMark-${index}`} id={`checkMark-${index}`}
                onClick={() => { setEditData(item); handleRowEdit(item, index) }}
                style={{ marginRight: '5px', width: '28px', padding: '1px 1px', height: '30px' }}
              >
                <CheckCircleOutlinedIcon tabIndex={0} style={{ color: '#4CAF50', marginTop: '1px' }} fontSize='large' />
              </span>
              <span key={`xMark-${index}`} tabIndex={0} id={`xMark-${index}`}
                onClick={() => handleCrossBtn(index)}
                style={{ marginRight: '5px', width: '28px', padding: '1px 1px', height: '30px' }}
              >
                <CancelOutlinedIcon tabIndex={0} style={{ color: 'red', marginTop: '1px' }} fontSize="large" />
              </span>
            </div>
          </TableCell>}
      </TableRow>
  )
  return (
    <>
      <Stack style={{ padding: '5px 0px', display: 'flex', flexDirection: 'row', gap: '16px' }} className="itemButtons">
        <Item sx={sx.itemsx}>
          <DropDownOA
            id='selectParty'
            label={tr('selectParty', 'Select Party')}
            data={partyList || []}
            width="100%"
            defaultvalue={filters?.partyName?.Party}
            value={filters?.partyName?.Party}
            searchPlaceholder={tr('searchCityName', 'Search City Name')}
            dataKey={`Party`}
            idKey={`PartyID`}
            onSelect={(val) => {
              setFilters((prev) => ({
                ...prev,
                partyName: val
              }))
            }}
            onSelResetVal={true}
            nextId={'serviceType'}
            prevId={'AddPartyRateBtn'}
          />
        </Item>
        <Item sx={sx.itemsx}>
          <DropDownOA
            key={`serviceType-${language}-${filters?.serviceType?.name}`}
            id='serviceType'
            label={tr('serviceType', 'Service Type')}
            data={translatedServiceTypeList}
            width="100%"
            defaultvalue={filters?.serviceType?.name}
            value={filters?.serviceType?.name}
            searchPlaceholder={tr('searchCityName', 'Search City Name')}
            dataKey={`name`}
            idKey={`id`}
            onSelect={(val) => {
              setFilters((prev) => ({
                ...prev,
                serviceType: val
              }))
            }}
            // onReset
            onSelResetVal={true}
            nextId={'ConsignmentType'}
            prevId={'selectParty'}
          />
        </Item>
        <Item sx={sx.itemsx}>
          <DropDownOA
            key={`consignmentType-${language}-${filters?.consignmentType?.id}-${filters?.consignmentType?.name}`}
            id='ConsignmentType'
            label={tr('consignmentType', 'Consignment Type')}
            data={consTypeList || []}
            width="100%"
            defaultvalue={filters?.consignmentType?.name}
            value={filters?.consignmentType?.name}
            searchPlaceholder={tr('searchCityName', 'Search City Name')}
            dataKey={`name`}
            idKey={`id`}
            onSelect={(val) => {
              setFilters((prev) => ({
                ...prev,
                consignmentType: val
              }))
            }}
            onSelResetVal={true}
            nextId={'billingUnit'}
            prevId={'serviceType'}
          />
        </Item>
        <Item sx={sx.itemsx}>
          <DropDownOA
            key={`billingUnit-${language}-${filters?.billingUnit?.name}`}
            id='billingUnit'
            label={tr('billingUnit', 'Billing Unit')}
            data={translatedBillingUnitList}
            width="100%"
            defaultvalue={filters?.billingUnit?.name}
            value={filters?.billingUnit?.name}
            searchPlaceholder={tr('searchBillingUnit', 'Search Billing Unit')}
            dataKey={`name`}
            idKey={`id`}
            onSelect={(val) => {
              setFilters((prev) => ({
                ...prev,
                billingUnit: val
              }))
            }}
            onSelResetVal={true}
            nextId={'status'}
            prevId={'ConsignmentType'}
          />
        </Item>
        <Item sx={sx.itemsx}>
          <DropDownOA
            key={`status-${language}-${filters?.status?.name}`}
            id='status'
            label={tr('gsStatus', 'Status')}
            data={translatedStatusListWithAll}
            width="100%"
            defaultvalue={filters?.status?.name}
            value={filters?.status?.name}
            searchPlaceholder={tr('searchStatus', 'Search Status')}
            dataKey={`name`}
            idKey={`id`}
            onSelect={(val) => {
              setFilters((prev) => ({
                ...prev,
                status: val
              }))
            }}
            onSelResetVal={true}
            nextId={'loadBtn'}
            prevId={'billingUnit'}
          />
        </Item>
        <Button
          id="loadBtn"
          style={{ margin: '0', height: "40px", width: '81px' }}
          className="btn add-btn"
          variant="contained"
          color="error"
          onClick={() => {
            getTableData()
          }}
          onKeyDown={(e) => navigation3(e, 'AddPartyRateBtn', 'status', () => { })}

        >
          {tr('loadLower', 'load')}
        </Button>
        <Button
          variant="outlined"
          id={'AddPartyRateBtn'}
          sx={{ width: '130px', padding: '5px', }}
          className="receiveitembtn"
          onKeyDown={(e) => navigation3(e, filteredData?.length > 0 ? 'editBtn-0' : 'selectParty', 'loadBtn', () => { getAddPartyRatesModalInfo() })}
          onClick={() => {
            getAddPartyRatesModalInfo()
          }}
        >
          {tr('addNewLower', '+ add new')}
        </Button>
        <Box >
          <Button
            variant="outlined"
            id={'AddPartyRateBtn'}
            sx={{ width: '130px', padding:'5px' }}
            className="receiveitembtn"
            // onKeyDown={(e) => navigation3(e, filteredData?.length > 0 ? 'editBtn-0' : 'selectParty', 'loadBtn', () => { getAddPartyRatesModalInfo() })}
            onClick={() => {
              clickElement('xls-buttons-dispatch')
            }}
          >
            {tr('excel', 'Excel')}
          </Button>
          <ReactHtmlTableToExcel
            id="xls-buttons-dispatch"
            table="tableExcel"
            filename={tr('viewRateMatrix', 'View Rate Matrix')}
            sheet="sheet 1"
            buttonText={tr('exportAsExcel', 'EXPORT AS EXCEL')}
            className="excel-button"
          />
        </Box>
      </Stack>
      <Stack style={{ maxHeight: '60vh', marginTop: '7px' }}>
        <TableContainer
          className="lr-popup-table lrModel  scrollBlue"
          style={{ border: '1px solid #ddd', borderBottomLeftRadius: '0px' }}
          component={Paper}
        >
          <Table
            style={{ border: 'none', overflow: 'auto' }}
            stickyHeader
            id="partyRateMatrixTbl"
            className="table1 table-Received "
            size="small"
            aria-label="a dense table"
          >
            <TableHead style={{ position: `sticky`, top: `0`, background: `white`, zIndex: '2' }}>
              <TableRow key="foc-tbl-header" style={{ background: '#d9edff' }}>
                {translatedColumnDefs.map((col, index) => (
                  <TableCell
                    key={`TH-${index}`}
                    style={{
                      ...col.headerSx,
                      verticalAlign: 'top',
                      backgroundColor: '#DAEDFE',
                      minHeight: '40px',
                      fontFamily: 'Roboto',
                      fontSize: '12px',
                      fontWeight: '600',
                      color: '#444444',
                    }}
                  >
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                      {col?.headerName?.split('\n')?.map((line, lineIndex) => (
                        <span key={`line-${lineIndex}`} style={{}}>
                          {line}
                        </span>
                      ))}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                {translatedColumnDefs.map((col, index) =>
                  col.showfilter ? (
                    <TableCell key={`FTH-${index}`} style={{ padding: '6px 6px' }}>
                      <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                        <input
                          id={`index-${index}`}
                          className="field"
                          name="cancelSearchInput"
                          style={{ width: '100%', height: '24px' }}
                          placeholder={tr('gsContains', 'Contains')}
                          value={searchData[col.field]}
                          onChange={(e) => handleSearchData(e, col.field)}
                        />
                        <FilterAltIcon style={{ color: '#aaa' }} />
                      </div>
                    </TableCell>
                  ) : (
                    <TableCell key={`empty-cell-${index}`}></TableCell>
                  )
                )}
              </TableRow>
            </TableHead>
            {filteredData?.length > 0 ? (
              <>
                <TableBody className="filter-data-row" style={{ border: 'none' }}>
                  {filteredData?.map((item, index) => renderPartyRateMatrixRow(item, index))}
                </TableBody>
              </>
            ) : (
              <>
                <TableBody>
                  <EmptyTableRow />
                </TableBody>
              </>
            )}
          </Table>
          <Table
            style={{ display: 'none', border: 'none', overflow: 'auto' }}
            stickyHeader
            id="tableExcel"
            className="table1 table-Received"
            size="small"
            aria-label="a dense table"
          >
            <TableHead style={{ position: `sticky`, top: `0`, background: `white`, zIndex: '2' }}>
              <TableRow>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '24px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={Math.floor(translatedColumnDefs1.length / 2)}
                >
                  <h3 style={{ paddingLeft: '17px' }}>{tr('partyRateMatrix', 'Party Rate Matrix')}</h3>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '24px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={translatedColumnDefs1.length - Math.floor(translatedColumnDefs1.length / 2)}
                >
                  <h3 style={{ paddingLeft: '17px' }}>{tr('companyNameColon', 'Company Name :')}{loginData.strCompanyName}</h3>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={translatedColumnDefs1.length}></TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '18px', fontWeight: '500', textAlign: 'left', backgroundColor: '#DAEDFE', }}
                  colSpan={3}
                >
                 {tr('selectParty', 'Select Party')}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '18px', fontWeight: '500', textAlign: 'left', backgroundColor: '#DAEDFE', }}
                  colSpan={3}
                >
                 {tr('serviceType', 'Service Type')}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '18px', fontWeight: '500', textAlign: 'left', backgroundColor: '#DAEDFE', }}
                  colSpan={3}
                >
                 {tr('consignmentType', 'Consignment Type')}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '18px', fontWeight: '500', textAlign: 'left', backgroundColor: '#DAEDFE', }}
                  colSpan={3}
                >
                {tr('billingUnit', 'Billing Unit')}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '18px', fontWeight: '500', textAlign: 'left', backgroundColor: '#DAEDFE', }}
                  colSpan={2}
                >
                {tr('gsStatus', 'Status')}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '18px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={3}
                >
                {filters?.partyName?.Party}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '18px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={3}
                >
                {tr(filters?.serviceType?.translationKey, filters?.serviceType?.name)}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '18px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={3}
                >
                 {tr(filters?.consignmentType?.translationKey, filters?.consignmentType?.name)}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '18px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={3}
                >
                {tr(filters?.billingUnit?.translationKey, filters?.billingUnit?.name)}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '18px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                {tr(filters?.status?.translationKey, filters?.status?.name)}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={translatedColumnDefs1.length}></TableCell>
              </TableRow>
              <TableRow key="foc-tbl-header" style={{ background: '#d9edff' }}>
                {translatedColumnDefs1.map((col, index) => (
                  <TableCell
                    key={`TH-${index}`}
                    style={{
                      ...col.headerSx,
                      verticalAlign: 'top',
                      backgroundColor: '#DAEDFE',
                      minHeight: '40px',
                      fontFamily: 'Roboto',
                      fontSize: '12px',
                      fontWeight: '600',
                      color: '#444444',
                    }}
                  >
                    {col.headerName}
                  </TableCell>
                ))}
              </TableRow>

            </TableHead>
            {filteredData?.length > 0 ? (
              <>
                <TableBody className="filter-data-row" style={{ border: 'none' }}>
                  {filteredData?.map((item, index) => (
                    <TableRow key={`auto-trans-recv-${index}`} style={{ minHeight: '36px' }}>
                      <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '2.54%', padding: '6px', textAlign: 'right' }}> {index + 1} </TableCell>
                      <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '4.42%', padding: '6px' }}>
                        {item.PartyID}
                      </TableCell>
                      <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '8.5%', padding: '6px', maxWidth: '120px' }}>
                        {item.Party}
                      </TableCell>
                      <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '4.94%', padding: '6px', maxWidth: '120px' }}>
                        {item.ServiceTypeID}
                      </TableCell>
                      <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '7.04%', padding: '6px', maxWidth: '120px' }}>
                        {item.ServiceType}
                      </TableCell>
                      <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '5.2%', padding: '6px' }}>{item.ConsignmentID}</TableCell>
                      <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '8.69%', padding: '6px', maxWidth: '116px' }}>
                        {item.ConsignmentType}
                      </TableCell>
                      <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '7.04%', padding: '6px', maxWidth: '94px' }}>
                        {item.BillingUnitName}
                      </TableCell>
                      <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '8.47%', padding: '6px', textAlign: 'left', maxWidth: '112px' }}>
                        {item.SourceCity}
                      </TableCell>
                      <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '8.47%', padding: '6px', textAlign: 'left', maxWidth: '112px' }}>
                        {item.DestinationCity}
                      </TableCell>
                      <TableCell style={{  fontSize: '12px', minHeight: '36px', color: '#444444', width: '8.47%', padding: '6px', textAlign: 'left', maxWidth: '112px' }}> {item.assignedRate} </TableCell>
                      {isSTA && <>
                        <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '8.47%', padding: '6px', textAlign: 'left', maxWidth: '112px' }}> {item.assignedDocumentCharge} </TableCell>
                        <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '8.47%', padding: '6px', textAlign: 'left', maxWidth: '112px' }}> {item.assignedValuationCharge} </TableCell>
                        <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '8.47%', padding: '6px', textAlign: 'left', maxWidth: '112px' }}> {item.assignedGoodsValue} </TableCell>
                        <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '8.47%', padding: '6px', textAlign: 'left', maxWidth: '112px' }}> {item.assignedDiscOnFreight} </TableCell>
                      </>}
                      <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '8.69%', padding: '6px', textAlign: 'left', maxWidth: '112px' }}>
                        {item.ModifiedBy}
                      </TableCell>
                      <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '13.5%', padding: '6px', textAlign: 'left' }}>{item?.ModifiedDate}</TableCell>
                      <TableCell sx={{  fontSize: '12px', minHeight: '36px', color: '#444444', width: '8.47%', padding: '6px', textAlign: 'left', maxWidth: '112px', width: '4.34%', textAlign: 'center' }}>
                        {item.active === 1 ? tr('gsActive', 'Active') : tr('inActive', 'InActive')}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </>
            ) : (
              <>
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={translatedColumnDefs1?.length}>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: '15px',
                            marginBottom: '15px',
                            color: 'red',
                            fontSize: '14px',
                          }}
                        >
                          <span>{tr('noResultsFoundShort', 'No results found.')}</span>
                        </div>
                      </TableCell>
                    </TableRow>
                  </TableBody>
              </>
            )}
          </Table>
        </TableContainer>
      </Stack>
      {showAddPartyRateModal && <AddNewPartyRatesModal dataValues={addPartyRateData} updateModal={setShowAddPartyRateModal} />}
      <SuccessAndErrorModal handleClose={() => { handleSuccessModalClose() }} open={isSuccess} title={cs.partyRateUpdatedSuccessfully || 'Party Rate Updated Successfully!'} modalStyle={modalStyle} />
    </>
  )
}
const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = { updateAlertError, getFocApprConsTypeData, getPartyConfigTableData, getPartyRateMatrixTableData, getParyRateUpdate, getCityList }
export default connect(mapStateToProps, mapDispatchToProps)(PartyRateMatrixTable)
